const LayoutConstants = {
    MIN_WIDTH_FOR_POPOVER: 496,
};

export default LayoutConstants;
